import { Empty } from 'antd'
import { doApi } from 'api'
import { doApi as modelingDoApi } from 'api/modelingApi'
import AppLoading from 'components/AppLoading'
import React from 'react'
import { AppPagination } from './AppPagination'
import { AppTableBody } from './AppTableBody'
import {
	AppTableColumn,
	AppTableColumnAction,
	AppTableColumnCheckbox,
	AppTableColumnDate,
	AppTableColumnDateTime,
	AppTableColumnIndex,
	AppTableColumnInt,
	AppTableColumnMoney,
	AppTableEditColumnDate,
	AppTableEditColumnInt,
	AppTableEditColumnMoney,
	AppTableEditColumnString,
} from './AppTableColumn'
import {
	getAllSelectStatus,
	getTableConfig,
	handleExpand,
	handleScroll,
	ITableLayout,
	toData,
	toTreeData,
	treeSelected,
} from './AppTableFunction'
import { AppTableHeader } from './AppTableHeader'

export interface AppTableContext {
	data?: any[]
	selectedRows?: any[]
	currRow?: any
	hoverRow?: any
	allSelectStatus?: number // 1是未选中  2是部分选中  3是选中
	rowClick?: (data: any) => void
	rowHover?: (data: any) => void
	rowSelected?: (data: any, checked: boolean) => void
	rowAllSelected?: (checked: boolean) => void
	hanldPagination?: (current: number, pageSize: number) => void
	handleExpand?: (data: any) => void
	updateData?: (dataIndex: number, field: string, value: any) => void
	sort?: (sortType: any, sortField?: any, Field?: any) => void
}

export const AppTableContext = React.createContext<AppTableContext>({} as AppTableContext)

export interface ITableProps extends IApi<any, { list?: any[]; total?: number }> {
	paging?: true | false
	tree?: true | false
	rowMode?: 'fixed' | 'free'
	rowHeight?: number
	defaultCurrent?: number
	pageSize?: number
	dataSource?: any[]
	rowKey?: string
	selectedRows?: any[]
	rowcilck?: (data: any) => void
	apiPath?: string
}

export class AppTable extends React.Component<ITableProps> {
	state = {
		ishidden: true,
		pageSize: 20,
		rowKey: 'id',
		current: 1,
		loading: true,
		dataSource: this.props.dataSource || [],
		total: 0,
		selectedRows: this.props.selectedRows || [],
		allSelectStatus: 1,
		currRow: {} as any,
		hoverRow: {} as any,
		queryData: this.props.data,
		tableConfig: getTableConfig(this.props.children),
		layout: { contentWidth: 0, bodyHeight: 0, marginright: '0' } as ITableLayout,
	}

	static Col = AppTableColumn
	static ColDate = AppTableColumnDate
	static ColDateTime = AppTableColumnDateTime
	static ColIndex = AppTableColumnIndex
	static ColInt = AppTableColumnInt
	static ColMoney = AppTableColumnMoney
	static ColCheckbox = AppTableColumnCheckbox
	static ColAction = AppTableColumnAction
	static ColEdit = AppTableEditColumnString
	static ColEditInt = AppTableEditColumnInt
	static ColEditMoney = AppTableEditColumnMoney
	static ColEditDate = AppTableEditColumnDate

	componentDidMount() {
		this.refBodyDiv && this.refBodyDiv.current && this.refBodyDiv.current.addEventListener('scroll', handleScroll)
		if (typeof this.props.dataSource !== 'undefined') {
			this.fetchDataSource(this.props.dataSource)
			return
		}
		this.fetchData()
		// this.refBodyDiv.current.addEventListener('resize',resizeTableBody)
	}

	shouldComponentUpdate() {
		if (this.state.tableConfig.columns.length === 0) return false
		if (this.props.data !== this.state.queryData) this.setState({ queryData: this.props.data })
		let { layout, tableConfig } = this.state
		let contentDiv = this.refContentDiv.current
		let contentWidth = contentDiv.clientWidth
		if (layout.contentWidth === 0) {
			layout.contentWidth = 1
			layout = { ...layout, contentWidth }
			if (tableConfig.tableWidth <= contentWidth) {
				tableConfig.currentWidth = -1
			} else {
				tableConfig.currentWidth = tableConfig.tableWidth
			}
			this.setState({ layout, tableConfig })
		}
		return true
	}

	sort = (sortType: any, sortField?: any, Field?: any) => {
		if (typeof this.props.dataSource !== 'undefined') {
			let dataSource = [...this.props.dataSource] // JSON.parse(JSON.stringify(this.props.dataSource)) as any[]
			switch (sortType) {
				case 'up':
					dataSource = dataSource.sort((a: any, b: any) => {
						return a[Field].localeCompare(b[Field])
					})
					break
				case 'down':
					dataSource = dataSource.sort((a: any, b: any) => {
						return b[Field].localeCompare(a[Field])
					})
					break
				default:
					break
			}
			this.fetchDataSource(dataSource)
			return
		} else {
			let orderBy = ''
			switch (sortType) {
				case 'up':
					orderBy = `${sortField} asc`
					break
				case 'down':
					orderBy = `${sortField} desc`
					break
				default:
					break
			}
			this.fetchData(orderBy)
		}
	}

	reLoadLayout = () => {
		let { layout } = this.state
		let bodyDiv = this.refBodyDiv.current
		let bodyHeight = bodyDiv.clientHeight
		if (bodyDiv.scrollHeight > bodyDiv.clientHeight && layout.marginright !== '7px') {
			layout.marginright = '7px'
		}
		if (layout.bodyHeight !== bodyHeight) {
			layout = { ...layout, bodyHeight }
			this.setState({ layout, marginRight: layout.marginright })
		}
	}

	handleResize = () => {
		this.reLoadLayout()
		let { layout, tableConfig } = this.state
		let contentDiv = this.refContentDiv.current
		let contentWidth = contentDiv.clientWidth
		layout = { ...layout, contentWidth }
		if (tableConfig.tableWidth <= contentWidth) {
			tableConfig.currentWidth = -1
		} else {
			tableConfig.currentWidth = tableConfig.tableWidth
		}
		this.setState({ layout, tableConfig })
	}

	componentWillUnmount ()  {
		this.refBodyDiv &&
			this.refBodyDiv.current &&
			this.refBodyDiv.current.removeEventListener('scroll', handleScroll)
		window.removeEventListener('resize', this.handleResize)
		// window.clearTimeout();
	}

	hanldPagination = (current: number, pageSize: number) => {
		this.setState({ current, pageSize }, this.fetchData)
	}

	fetchDataSource = (dataSource: any[]) => {
		const { tableConfig } = this.state
		dataSource = tableConfig.tree ? toTreeData(dataSource) : toData(dataSource, 0)
		this.setState({ dataSource, loading: false })
	}

	getSelected = () => {
		let { tableConfig } = this.state
		return tableConfig.multSelect ? this.state.dataSource.filter(e => e.__table_checked) : [this.state.currRow]
	}

	rowClick = (currRow: any) => {
		this.props.rowcilck && this.props.rowcilck(currRow)
		this.setState({ currRow })
	}

	rowHover = (hoverRow: any) => {
		if (hoverRow === null) hoverRow = {}
		this.setState({ hoverRow })
	}

	updateData = (dataIndex: number, field: string, value: any) => {
		let { dataSource } = this.state
		dataSource[dataIndex][field] = value
		this.setState({ dataSource })
	}

	getGridData = () => {
		return this.state.dataSource
	}

	rowSelected = (data: any, checked: boolean) => {
		let { dataSource, tableConfig } = this.state

		if (tableConfig.tree) {
			dataSource = treeSelected(dataSource, data, checked)
		} else {
			let key = this.props.rowKey || 'id'
			dataSource.forEach((item: any) => {
				if (data[key] === item[key]) {
					item.__table_checked = checked
				}
			})
		}

		let allSelectStatus = getAllSelectStatus(dataSource)
		this.setState({ dataSource, allSelectStatus })
	}

	rowAllSelected = (checked: boolean) => {
		let { dataSource } = this.state
		dataSource.forEach((item: any) => {
			item.__table_checked = checked
		})
		let allSelectStatus = getAllSelectStatus(dataSource)
		this.setState({ dataSource, allSelectStatus })
	}

	handleExpand = (rowData: any) => {
		let dataSource = handleExpand(rowData, this.state.dataSource)
		this.setState({ dataSource })
	}

	queryGrid = (queryData: any) => {
		queryData = { ...this.state.queryData, ...queryData }
		this.setState({ queryData }, this.fetchData)
	}

	refreshData = (current?: number) => {
		if (typeof current === 'undefined') current = 1
		this.setState({ current, loading: true }, this.fetchData)
	}

	private fetchData = async (orderBy?: string) => {
		const { current, pageSize, queryData, tableConfig } = this.state
		let { paging, api, onApiBefore, onApiAfter } = this.props
		let data = { ...queryData }
		if (orderBy && orderBy !== '') {
			data = { ...data, orderBy }
		}

		try {
			let extraApiData = { size: pageSize!, page: current, paging: paging! }
			let apiResult = {} as any
			let apiPath = this.props.apiPath || ''
			if (apiPath !== '') {
				extraApiData = { size: pageSize!, page: current, paging: paging! }
				apiResult = await modelingDoApi({
					api,
					onApiBefore,
					onApiAfter,
					data,
					extraApiData,
					apiPath,
				})
			} else {
				apiResult = await doApi({
					api,
					onApiBefore,
					onApiAfter,
					data,
					extraApiData,
				})
			}
			let dataSource = apiResult.list || (Array.isArray(apiResult) && apiResult) || []
			dataSource = tableConfig.tree ? toTreeData(dataSource) : toData(dataSource, (current - 1) * pageSize)

			this.setState({
				dataSource,
				loading: false,
				total: apiResult.total!,
				current,
			})
		} catch (ex) {
			this.setState({ loading: false })
		}
	}

	renderPagination = () => {
		if (this.props.paging) {
			return (
				<AppPagination current={this.state.current} total={this.state.total} pageSize={this.state.pageSize} />
			)
		}
		return <React.Fragment />
	}

	renderRight = () => {
		let { tableConfig, layout } = this.state
		if (tableConfig.rightAreaWidth === 0 || tableConfig.currentWidth === -1) return <React.Fragment />
		return (
			<div
				className="app-table-content-right"
				style={{ width: tableConfig.rightAreaWidth, marginRight: layout.marginright }}
			>
				<div className="app-table-header-fixed">
					<AppTableHeader columns={tableConfig.rightColumns} />
				</div>
				<div className="app-table-body-right-fixed" style={{ height: layout.bodyHeight }}>
					<AppTableBody columns={tableConfig.rightColumns} width={tableConfig.rightAreaWidth} />
				</div>
			</div>
		)
	}

	renderLeft = () => {
		let { tableConfig } = this.state
		if (tableConfig.leftAreaWidth === 0 || tableConfig.currentWidth === -1) return <React.Fragment />
		return (
			<div className="app-table-content-left" style={{ width: tableConfig.leftAreaWidth, display: 'none' }}>
				<div className="app-table-header">
					<AppTableHeader columns={tableConfig.leftColumns} />
				</div>
				<div className="app-table-body-left-fixed" style={{ height: this.state.layout.bodyHeight }}>
					<AppTableBody columns={tableConfig.leftColumns} width={tableConfig.leftAreaWidth} />
				</div>
			</div>
		)
	}

	refContentDiv = React.createRef<HTMLDivElement>()
	refBodyDiv = React.createRef<HTMLDivElement>()
	refheaderDiv = React.createRef<HTMLDivElement>()

	renderMainBody = () => {
		let { dataSource, tableConfig, layout } = this.state
		if (layout.contentWidth === 0) return <React.Fragment />

		if (dataSource.length === 0)
			return (
				<div style={{ width: tableConfig.currentWidth }}>
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</div>
			)

		return (
			<AppTableBody
				columns={tableConfig.columns}
				width={tableConfig.currentWidth}
				reLoadLayout={this.reLoadLayout}
			/>
		)
	}
	handlehidden = (ishidden: boolean) => {
		this.setState({ ishidden })
	}
	renderMainHeader = () => {
		let { tableConfig, layout } = this.state
		if (layout.contentWidth === 0) return <React.Fragment />
		return <AppTableHeader columns={tableConfig.columns} width={tableConfig.currentWidth} />
	}

	renderMain = () => {
		let { layout, ishidden } = this.state
		if (this.state.tableConfig.columns.length === 0) return <React.Fragment />
		return (
			<div className="app-table-content-main" ref={this.refContentDiv}>
				<div className="app-table-header" style={{ paddingRight: layout.marginright }} datatype={`${ishidden}`}>
					<div
						className="app-table-header-inner"
						ref={this.refheaderDiv}
						onScroll={e => handleScroll(e, ishidden, this.handlehidden || null)}
					>
						{this.renderMainHeader()}
					</div>
				</div>
				<div className="app-table-body" ref={this.refBodyDiv}>
					{this.renderMainBody()}
				</div>
			</div>
		)
	}

	render() {
		return (
			<AppTableContext.Provider
				value={{
					data: this.state.dataSource,
					selectedRows: this.state.selectedRows,
					currRow: this.state.currRow,
					hoverRow: this.state.hoverRow,
					rowClick: this.rowClick,
					rowHover: this.rowHover,
					rowSelected: this.rowSelected,
					rowAllSelected: this.rowAllSelected,
					hanldPagination: this.hanldPagination,
					allSelectStatus: this.state.allSelectStatus,
					handleExpand: this.handleExpand,
					updateData: this.updateData,
					sort: this.sort,
				}}
			>
				<div className="app-table-container">
					{this.state.dataSource ? null : <AppLoading />}
					<div className="app-table">
						<div className="app-table-content">
							{this.renderMain()}
							{this.renderLeft()}
							{this.renderRight()}
						</div>
						{this.renderPagination()}
					</div>
				</div>
			</AppTableContext.Provider>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppTable/AppTable.tsx